import React from 'react';
import NavBar from '../AppBar/AppBar';
import appStoreIcon from '../../Assets/button/appstore.png';
import playStoreIcon from '../../Assets/button/googleplay.png';
import moment from 'moment';
import { useTailwindBrand } from '../shared';

interface MaintenanceLayoutProps {
  title: string;
  description: string;
  buttonText?: string;
  buttonLink?: string;
  showNavbar?: boolean;
  showAppStoreButtons?: boolean;
  maintenanceInfo?: {
    startDate: string;
    endDate: string;
  };
  step?: number;
  className?: string;
}

const MaintenanceLayout: React.FC<MaintenanceLayoutProps> = ({
  title,
  description,
  buttonText,
  buttonLink,
  showNavbar = false,
  showAppStoreButtons = false,
  maintenanceInfo,
  step,
  className = ""
}) => {
  const currentDate = moment().format('DD/MM/YYYY');
  const {classes, common} = useTailwindBrand()

  return (
    <div className={`h-screen overflow-hidden ${className}`}>
      {showNavbar && step !== undefined && (
        <NavBar index={step} />
      )}
      
      <div className="flex flex-col h-screen gap-8 px-4 pt-8 bg-bottom bg-no-repeat bg-contain bg-comingSoon md:px-16">
        <div className="lg:w-1/2 w-full mt-[83px] md:p-8 p-4 space-y-8">
          <h1 className={`${classes.primaryText} lg:text-[32px] text-[20px] md:text-[28px] font-semibold`}>
            {title}
          </h1>
          
          <p className={`${common.body} lg:text-2xl md:text-lg text-base font-semibold leading-8`}>
            {description}
            
            {maintenanceInfo && (
              <>
                <br />
                <span>{maintenanceInfo.startDate.replace('{date}', currentDate)}</span>
                <br />
                <span>{maintenanceInfo.endDate.replace('{date}', currentDate)}</span>
              </>
            )}
          </p>
          
          {buttonText && buttonLink && (
            <button 
              // onClick={() => window.open(buttonLink, '_self')} 
              className={`rounded-full ${classes.primaryBg} text-white w-full text-center mx-auto font-bold p-1 lg:text-lg md:text-base text-sm`}
            >
              <a href={buttonLink}>{buttonText}</a>
            </button>
          )}
        </div>
        
        {showAppStoreButtons && (
          <div className="flex items-center justify-between gap-4 py-8 text-center md:w-2/4 lg:hidden">
            <div>
              <img src={appStoreIcon} alt="App Store" />
            </div>
            <div>
              <img src={playStoreIcon} alt="Play Store" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MaintenanceLayout; 